<template>
  <MasterTable
    title="Orsakskategorier"
    :rows="categories"
    :columns="columns"
    :loading="loading"
    :add="add"
    :update="update"
    :remove="remove"
    :reset-form-model="resetFormModel"
    :form-model="model"
    :export-data="exportData"
    remove-item-text-prop="name"
    @update-form-model="(row) => (model = row)"
  >
    <template v-slot:form>
      <div class="row" style="min-width: 300px">
        <div class="col-12 q-pa-md">
          <div class="row">
            <div class="col-12">
              <q-input
                dense
                v-model="model.name"
                label="Namn*"
                :rules="[requiredRule]"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </MasterTable>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import MasterTable from '@/components/master/MasterTable.vue'
import { required as requiredRule } from '@/common/formValidationRules'
import { v4 as uuidv4 } from 'uuid'
import { Category } from '@/types/category'
import { useCategory } from '@/composable/useCategory'

export default defineComponent({
  name: 'Categories',

  components: {
    MasterTable,
  },

  setup() {
    const {
      loading: loadingState,
      data: categories,
      add,
      update,
      remove,
    } = useCategory(true)

    function createFormModel(): Partial<Category> {
      return {
        uuid: uuidv4(),
        name: '',
      }
    }
    const model = ref<Partial<Category>>(createFormModel())

    function resetFormModel() {
      model.value = createFormModel()
    }

    const columns = [
      {
        name: 'name',
        label: 'Namn',
        align: 'left',
        field: 'name',
        sortable: true,
      },
    ]

    const loading = computed(() => {
      return {
        ...loadingState.value,
      }
    })

    const exportData = computed(() => {
      return categories.value.map((category) => {
        return {
          Namn: category.name,
        }
      })
    })

    return {
      columns,
      model,
      requiredRule,
      categories,
      add,
      remove,
      update,
      loading,
      resetFormModel,
      exportData,
    }
  },
})
</script>
